<template lang="html">
    <div class="welcome-benefit">
        <span class="icon" :class="iconClass"></span>
        <h2 v-html="title"></h2>
        <div class="welcome-benefit-content" v-html="content"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false
        }
    },
    computed: {
        iconClass() {
            return 'icon-' + this.icon;
        }
    }
};
</script>

<style lang="less">
@import '../../less/variables';

.welcome-benefit {
    .icon {
        font-size: 50px;
        color: @color-1;
    }
    h2 {
        text-transform: uppercase;
        margin-bottom: 20px;
    }
    margin: 40px 0;
    text-align: center;
    .welcome-benefit-content {
        text-align: left;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/welcome-benefit-block.vue